module.exports = __webpack_public_path__ + "static/img/cnlogo.0fb030e5.jpg";